// import this after install `@mdi/font` package
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure your project is capable of handling css files

import "vuetify/styles";
import { createVuetify } from "vuetify";

import { aliases, md } from "vuetify/iconsets/md";
import { mdi } from "vuetify/iconsets/mdi";

// import { VNumberInput } from "vuetify/labs/VNumberInput";
// import { VDateInput } from 'vuetify/labs/VDateInput'
import { VFileUpload, VFileUploadItem } from "vuetify/labs/VFileUpload";

import locale from "~/utils/locale";
import { pt } from "vuetify/locale";

const formDefaultsConfig = {
  variant: "outlined",
  density: "compact",
};

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    components: { VFileUpload, VFileUploadItem },
    theme: {
      defaultTheme: "funarpen",
      themes: {
        funarpen: {
          dark: false,
          colors: {
            background: "#f4f8fb",
            surface: "#ffffff",
            primary: "#0b4f6c",
            secondary: "#13768a",
            accent: "#bf9851",
            info: "#2d7fa3",
            success: "#1d7f5f",
            warning: "#b7791f",
            error: "#9f2d2d",
            "on-primary": "#ffffff",
            "on-secondary": "#ffffff",
            "on-surface": "#102334",
          },
        },
      },
    },
    defaults: {
      VTextField: { ...formDefaultsConfig },
      VAutocomplete: { ...formDefaultsConfig },
      VSelect: { ...formDefaultsConfig },
      VTextarea: { ...formDefaultsConfig },
      VCheckbox: { ...formDefaultsConfig },
    },
    icons: {
      defaultSet: "mdi",
      //   aliases,
      sets: {
        md,
        mdi,
      },
    },
    locale: {
      locale: "locale",
      fallback: "pt",
      messages: { pt, locale },
    },
  });

  app.vueApp.use(vuetify);
});
